import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { ProductosMasVendidosInterface } from "../interfaces/productosMasVendidos.interface";

export async function getProductosMasVendidosAction(
  limit: number
): Promise<ApiResponse<ProductosMasVendidosInterface>> {
  const { data } = await apiClient.get<ProductosMasVendidosInterface>(
    "reports/productos/mas-vendidos",
    { params: { limit } }
  );

  return {
    status: 200,
    data,
    message: "Productos más vendidos obtenidos correctamente",
  };
}
